import api from '@/api/axiosApi'
import type {
  BackupDaysMode,
  BackupDaysRow,
  PaginatedBackupDaysResponse,
} from './clt.types'

export interface ListBackupDaysParams {
  origin?: string
  wh?: number
  skip?: number
  limit?: number
}

export async function listBackupDays(
  params: ListBackupDaysParams = {}
): Promise<PaginatedBackupDaysResponse> {
  const { origin, wh, skip = 0, limit = 2000 } = params
  const response = await api.get<PaginatedBackupDaysResponse>(
    '/backup-days-matrix',
    {
      params: {
        origin: origin || undefined,
        wh: wh ?? undefined,
        skip,
        limit,
      },
    }
  )
  return response.data
}

export async function updateBackupDays(
  origin: string,
  wh: number,
  mode: BackupDaysMode,
  days: number
): Promise<BackupDaysRow> {
  const response = await api.put<BackupDaysRow>(
    `/backup-days-matrix/${encodeURIComponent(origin)}/${wh}/${mode}`,
    { days }
  )
  return response.data
}
